import {StyleSheet} from "aphrodite";
import * as React from "react";
import type {RenderElementProps} from "slate-react";

import {Body} from "@khanacademy/wonder-blocks-typography";

export default function TableBodyNode(
    props: RenderElementProps,
): React.ReactElement {
    const {attributes, children} = props;

    return (
        <Body {...attributes} style={styles.tbody} tag="tbody">
            {children}
        </Body>
    );
}

const styles = StyleSheet.create({
    tbody: {
        display: "table-row-group",
    },
});
